import { ReactNode } from "react";

import { ApplicationBarToolbar, PageContent, PageMain } from "@impero-com/ui";

import { useNewMenu } from "../../org/navigation/useNewMenu";

interface PageNavMenuMainProps {
    navigation?: ReactNode;
    actions?: ReactNode;
    children: ReactNode;
}

export function PageNavMenuMain({
    navigation,
    actions,
    children,
}: PageNavMenuMainProps) {
    const newMenu = useNewMenu();

    return (
        <PageMain
            toolbar={
                (navigation || actions) && (
                    <ApplicationBarToolbar
                        navigation={navigation}
                        actions={actions}
                    />
                )
            }
            variant={newMenu ? "flat" : "default"}
        >
            <PageContent>{children}</PageContent>
        </PageMain>
    );
}
